module.exports = __webpack_public_path__ + "img/logo-full.1f30a92e.png";